/**
 * Sekcja Akcesoria na karcie produktu:
 * Dodanie do koszyka, wyświetlenie grupy produktow
 * @type module
 */

//wszystkie zmiany muszą być odzwierciedlone w productTabMatches.js productTabSeeAlso.js
app.service('productTabAccessories',function(loading, productCardConfig, console, front, cartManager) {
	var $self, $list, $categories, $wcFilter;
	var lastGroupId='0';
	var $ajax;
	var config;

	function load(groupId,init) {
		lastGroupId=groupId;
		var data={
			'product-link-name':config.linkName,
			'group-id':groupId,
		};
		if(init){
			data.init=true;
			$self.addClass('loading');
		}else{
			$list.addClass('loading');
		}
		if(front.katalog){
			data.wcProductCriteriaName=$wcFilter.val();
		}
		if($ajax){
			$ajax.abort();
		}
		$ajax=$.ajax({
			url:'/product-card-accessory.ltr',
			data:data,
			success:function(html){
				loadSuccess(html,init);
			},
			error:function(){
				console.log('Błąd ładowania akcesorii');
			},complete:function(){
				if(init){
					$self.removeClass('loading');
				}else{
					$list.removeClass('loading');
				}
			}
		});
	}
	function loadSuccess(html,init) {
		if(init){
			$('.accessories-groups, .js-accessories-list', $self).remove();
			$('#accessories-filter').after(html);
			setElements();
		}else{
			$list.html(html);
		}
		$self.productSlider();
		checkCart();
	}
	function checkCart() {
		cartManager.checkRelatedProducts();
	}
	function addToCartClick(id, checked) {
		cartManager.clickRelatedProducts(id,checked,'ACCESS_CARD', config.plu);
	}
	function changeGroupClick(group) {
		load(group,false);
		selectNewGroup(group);
	}
	function selectNewGroup(group) {
		$categories.filter('.active').removeClass('active').addClass('inactive');
		$categories.filter('[data-group='+group+']').removeClass('inactive').addClass('active');
	}
	function showMoreCategories() {
		$self.addClass('show-all-categories');
	}
	function setEvents(){
		$self.on('click', '.js-add-accessory-to-cart-checkbox', function(event){
			addToCartClick($(this).val(), $(this).is(':checked'));
		});
		$self.on('click', '.js-category-access', function(event){
			UA.interaction('KP', 'Akcesoria', 'Wybór grupy akcesoryjnej - ' + $(this).text().trim());
			changeGroupClick($(this).data('group'));
		});
		$(document).on('cartReady', function(){
			checkCart();
		});
		$self.on('click','.js-category-access-more', function(event){
			showMoreCategories();
		});
		$self.on('click', '.js-product-slider-previous', function(){
			UA.interaction('KP', 'Akcesoria', 'Karuzela - Lewo');
		});
		$self.on('click', '.js-product-slider-next', function(){
			UA.interaction('KP', 'Akcesoria', 'Karuzela - Prawo');
		});
		if(front.katalog){
			$wcFilter.change(function(){
				initLoad();
			});
		}
	}
	function setElements() {
		$list = $('.js-accessories-list', $self);
		$categories=$('.js-category-access', $self);
		$self.productSlider();
	}
	function initLoad(){
		load(0,true);
	}
	function init() {
		$self = $('#accessories');
		config = productCardConfig.getData();
		if(front.katalog){
			$wcFilter=$('#wc-product-card-accessories-filter', $self);
			setEvents();
			initLoad();
		}else{
			setElements();
			setEvents();
		}
	}
	return {
		init:init
	};
});
